import { Box, CircularProgress } from "@mui/material";

const PageLoader = () => {
  return (
    <Box
      sx={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        p: 4,
        overflow: "auto",
      }}
    >
      <CircularProgress />
    </Box>
  );
};
export default PageLoader;
